import { ANSWER_MAX_CHARS } from './session.js';

/*
 * Iter 20 — «Карусель из своего текста». A hidden carousel idea whose three
 * answers carry the author's text (a_1), the edit mode (a_2) and the optional
 * call to action (a_3). The idea row and its prompt live in
 * scripts/iter20-carousel-own-text.sql; the mode labels and the no-CTA sign
 * below are quoted there verbatim.
 */
export const OWN_TEXT_IDEA_CODE = 'carousel_own_text';

// Below this a 6-slide carousel cannot be built without inventing text.
export const OWN_TEXT_MIN_CHARS = 400;
export const OWN_TEXT_MAX_CHARS = ANSWER_MAX_CHARS;

export const OWN_TEXT_MODES = ['Текст готов', 'Поправь аккуратно'] as const;
export type OwnTextMode = (typeof OWN_TEXT_MODES)[number];

/** Stored in a_3 when the author left the call-to-action field empty. */
export const OWN_TEXT_NO_CTA = '-';

/** Answers payload for PATCH /sessions/:id/answers of an own-text session. */
export function ownTextAnswers(
  text: string,
  mode: OwnTextMode,
  cta: string,
): Record<string, string> {
  return { a_1: text.trim(), a_2: mode, a_3: cta.trim() || OWN_TEXT_NO_CTA };
}
